module.exports = __webpack_public_path__ + "static/media/march.468048b1.png";